/** What an empty time box shows in grey; typed digits replace it from the left. */
export const TIME_TEMPLATE = "00:00";

/** "1430" → "14:30", "143" → "14:3", "14" → "14": the colon appears once minutes start. */
export const formatTimeDigits = (digits: string): string =>
  digits.length > 2 ? `${digits.slice(0, 2)}:${digits.slice(2)}` : digits;

/** Whether `digit` can follow the `typed` digits and still lead to a time from 00:00 to 23:59. */
const isDigitAllowed = (typed: string, digit: string): boolean => {
  const value = Number(digit);
  switch (typed.length) {
    case 0:
      return value <= 2;
    case 1:
      return typed === "2" ? value <= 3 : true;
    case 2:
      return value <= 5;
    default:
      return typed.length === 3;
  }
};

/**
 * The digits of what is in the box, or null when any of them can't lead to a real time. The
 * edit is then refused whole: replacing the 3 of "14:30" with a 6 must not cut it to "14".
 */
export const acceptDigits = (raw: string): string | null => {
  let digits = "";
  for (const digit of raw.replace(/\D/g, "").slice(0, 4)) {
    if (!isDigitAllowed(digits, digit)) return null;
    digits += digit;
  }
  return digits;
};

/** The time the box reads as: the typed digits, the rest taken from the grey template. */
export const completeTime = (digits: string): { hours: number; minutes: number } | null => {
  if (!digits) return null;
  const full = digits + "0000".slice(digits.length);
  return { hours: Number(full.slice(0, 2)), minutes: Number(full.slice(2)) };
};
